import { makeStyles } from '@material-ui/styles'
import { Typography as Text } from 'antd'
import React from 'react'

import DurationFilterLabel from './DurationFilterLabel'
import ReportLogoHeader from './ReportLogoHeader'

/**
 * @typedef ReportPrintContainerProps
 * @property {React.MutableRefObject<HTMLDivElement>} printRef
 * @property {string} start
 * @property {string} end
 * @property {string} title
 * @property {JSX.Element|JSX.Element[]} [children]
 * @property {boolean} [withPageBreak=false]
 */
export default function ReportPrintContainer(props) {
  const { printRef, start, end, title, children, withPageBreak = false } = props
  const classes = useStyles(props)

  // 先轉成陣列，處理單一 child / null / fragment 等情況
  const items = React.Children.toArray(children)

  // 只在「第二個區塊之後」強制換頁；不要對整個 child 外層加 break-inside: avoid
  const content = withPageBreak
    ? items.map((child, i) => (
        <div key={i} className={i > 0 ? classes.pageBreakBefore : undefined}>
          {child}
        </div>
      ))
    : children

  return (
    <div ref={printRef} className={classes.print}>
      <div className={classes.headerBlock}>
        <ReportLogoHeader />
        <br />
        <Text className={classes.title}>{title}</Text>
        <DurationFilterLabel start={start} end={end} />
      </div>

      {content}
    </div>
  )
}

const useStyles = makeStyles(() => ({
  print: {
    '@media screen': {
      overflow: 'hidden',
      height: 0, // 保留在 DOM 中，react-to-print 才抓得到
    },
    '@media print': {
      display: 'block',
      // 讓顏色與間距在列印時更一致
      WebkitPrintColorAdjust: 'exact',
      printColorAdjust: 'exact',
    },
  },

  // 避免「Logo/標題/期間」被拆頁，但不影響後面內容的自動切頁
  headerBlock: {
    '@media print': {
      breakInside: 'avoid',
      pageBreakInside: 'avoid',
    },
  },

  title: {
    fontSize: 24,
    fontWeight: 'bold',
    textAlign: 'center',
  },

  // 用「頁首換頁」而不是「上一段的頁尾換頁」，可避免第一頁大片空白
  pageBreakBefore: {
    '@media print': {
      pageBreakBefore: 'always',
      breakBefore: 'page',
    },
  },
}))
